import { useCallback, useEffect, useState } from 'react';
import { Award } from 'react-bootstrap-icons';

import EmptyState from '@/components/shared/EmptyState';
import HorizontalList from '@/components/shared/HorizontalList';
import PageTitle from '@/components/shared/PageTitle';
import Wrapper from '@/components/shared/Wrapper';
import CertificateProps from '@/interfaces/certificates';
import certificateService from '@/services/certificates';

import Card from './Card';

const CertificatesPage = () => {
  const [loading, setLoading] = useState(true);
  const [certificates, setCertificates] = useState<CertificateProps[]>([]);

  const listCertificates = useCallback(async () => {
    try {
      const { data } = await certificateService.list();
      setCertificates(data);
      setLoading(false);
    } catch (error) {
      // TODO: handle error
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    listCertificates();
  }, [listCertificates]);

  const hasCertificates = certificates.length > 0;

  return (
    <Wrapper>
      <PageTitle title='Certificados' />

      {!loading && !hasCertificates && (
        <EmptyState
          icon={<Award />}
          title='Todos os seus certificados aparecerão aqui.'
          description='Aqui você poderá consultar e baixar todos seus certificados.'
        />
      )}

      <HorizontalList isFetching={loading}>
        {certificates.map(certificate => (
          <Card {...certificate} key={certificate.id} />
        ))}
      </HorizontalList>
    </Wrapper>
  );
};

export default CertificatesPage;
